var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconMenuKabob(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(41.000000, 11.000000)", fill: color },
                React.createElement("path", { d: "M8.59955039,60.1964496 C13.3488837,60.1964496 17.1988992,64.0464651 17.1988992,68.7957984 C17.1988992,73.5453333 13.3488837,77.3953488 8.59955039,77.3953488 C3.8500155,77.3953488 -2.30926389e-14,73.5453333 -2.30926389e-14,68.7957984 C-2.30926389e-14,64.0464651 3.8500155,60.1964496 8.59955039,60.1964496" }),
                React.createElement("path", { d: "M8.59955039,30.098124 C13.3488837,30.098124 17.1988992,33.9483411 17.1988992,38.6976744 C17.1988992,43.4470078 13.3488837,47.2972248 8.59955039,47.2972248 C3.8500155,47.2972248 -2.30926389e-14,43.4470078 -2.30926389e-14,38.6976744 C-2.30926389e-14,33.9483411 3.8500155,30.098124 8.59955039,30.098124" }),
                React.createElement("path", { d: "M8.59955039,1.77635684e-15 C13.3488837,1.77635684e-15 17.1988992,3.8500155 17.1988992,8.59955039 C17.1988992,13.3488837 13.3488837,17.1988992 8.59955039,17.1988992 C3.8500155,17.1988992 -2.30926389e-14,13.3488837 -2.30926389e-14,8.59955039 C-2.30926389e-14,3.8500155 3.8500155,1.77635684e-15 8.59955039,1.77635684e-15" })))));
}
//# sourceMappingURL=icon.menu-kabob.component.js.map